import axios from 'axios';
import { API_BASE_URL } from '../constants';

export default class OtherAssetsTaskManagerService {
	static instance;

	static getInstance() {
		if (!OtherAssetsTaskManagerService.instance) {
			OtherAssetsTaskManagerService.instance = new OtherAssetsTaskManagerService();
		}

		return OtherAssetsTaskManagerService.instance;
	}

    async fetchTasks(assetId, params = {}){
        const response = await axios.post(`${API_BASE_URL}/other_asset/${assetId}/tasks`, params, {
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            },
        });
        return response.data.data
    }
}